jQuery(function($)
{
    $('[data-conditional-prefill]').each(function()
    {
        var
            $target = $(this),
            $conditional = $('#' + $target.data('conditional-prefill')),
            $source = $('#' + $target.data('conditional-prefill-source'));

        if (0 === $conditional.length || 0 === $source.length)
        {
            return;
        }

        function handleClick()
        {
            if (!$conditional.is(':checked'))
            {
                return;
            }

            if ($target.val().length > 0)
            {
                return;
            }

            $target
                .val($source.val())
                .trigger('input');
        }

        $conditional.on('click', handleClick);
    });
});
